import React, { useState, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  Card,
  CardBody,
  DateRangPickerField,
} from "../../../_metronic/_partials/controls";
import { Col, Row, Button, Accordion } from "react-bootstrap";
import moment from "moment";
import  {imageUrl} from "../../components/UIHelpers";
import * as actions from "./_redux/Actions";
import {
  dateFormatCol,
  dateTimeFormatCol,
} from "../../components/column-formatters";
import * as UIHelpers from "../../components/UIHelpers";
import "./ContestList.css";

import sorter from "sort-nested-json";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import * as columnFormatters from "../../components/column-formatters";
import { NotificationContainer, NotificationManager } from "react-notifications";
import { Formik, Field } from "formik";
import DataTable from "../../components/DataTable";

import { teamColumn } from "./allocatedTeamColumn";

export const initialFilter = {
  sort: "desc", // asc||desc
  sortBy: "createdAt",
  skip: UIHelpers.skip,
  limit: UIHelpers.limit,
  page: UIHelpers.page
};

export default function AcceptedUserList(props) {
  const dispatch = useDispatch();

  const [rows, setRows] = useState([]);
  const [totalRecord, setTotalRecord] = useState(0);
  const [allColumns, setAllColumns] = useState(teamColumn);
  const [cols, setCols] = useState(teamColumn);
  const [sortDirection, setSortDirection] = useState([]);
  const [showSortArrow, setShowSortArrow] = useState([]);
  const [contestInfo, setContestInfo] = useState({});
  const [searchApply, setSearchApply] = useState(false);
  const [filter, setFilter] = useState(initialFilter);
  const [collasibleRowData, setCollasibleRowData] = useState({});
  const [phoneEmail, setPhoneEmail] = useState("");

  const { currentState } = useSelector(
    (state) => ({ currentState: state.tournamentsSlice }),
    shallowEqual
  );

  const {
    actionsLoading,
    listLoading,
    acceptedUserList,
    contestData
  } = currentState;

  useEffect(() => {
    var id = window.location.href.split("/")[
      window.location.href.split("/").length - 1
    ];
    dispatch(actions.fetchContestViewDetails(id));
  }, []);

  useEffect(() => {
    if (contestData && contestData?.data && contestData?.data?.tournamentAry) {
      var id = window.location.href.split("/")[
        window.location.href.split("/").length - 1
      ];
      let obj = {
        tournamentId: contestData?.data?.tournamentAry?._id,
        matchId: id
      }
      //dispatch(actions.fetchAcceptedUsersList(obj));
      setContestInfo(contestData)
    }
  }, [contestData]);

  useEffect(() => {
    let temp1 = [];
    temp1.push(
      {
        dataField: "plusMinusIcon",
        text: "+",
        sort: false,
        show: true,
        format: {
          type: 'collasibleDataIcon',
          formatfunction: {
            onClickIcon: onClickIcon,
            returnCollasibleData: returnCollasibleData,
          }
        },
      },
    );


    allColumns.map((item, index) => {
      if (item?.show === true) {
        temp1.push(item);
      }
    });

    // if(temp1.requestStatus=="canceled"){
    temp1.push(
      {
        dataField: "action",
        text: "Actions",
        sort: false,
        show: true,
        format: {
          type: 'action',
          style: {
            width: "150px",
          },
          formatfunction: {
            allocateTeamItem: allocateTeamItem
          }
        },
      }
    );

    //}

    setAllColumns(temp1);
  }, [teamColumn]);

  const allocateTeamItem = (row_value) => {
    let obj = {
      "tournamentId": row_value?.tournamentMatchDetailsData?.tournamentId,
      "roundId": row_value?.tournamentMatchDetailsData?.roundId,
      "matchId": row_value?.tournamentMatchDetailsData?._id,
      "teamId": row_value._id
    }

    dispatch(actions.allocateUserToContest(obj)).then((sucess) => sucess ? reloadLocation() : null);
  }

  const onClickIcon = (row_value) => {
    console.log("row_value", row_value)
  }

  const returnCollasibleData = (row_value, collasible_row_data) => {
    let data = collasible_row_data[row_value?.phone];
    if (data) {
      return (
        <div className="d-flex flex-column flex-grow-1 pr-8 bg-secondary">
          <div className="d-flex flex-wrap">
            <table className="w-100">
              <tr>
                <th>User Id</th>
                <th>Phone</th>
                <th>Player Name</th>
                <th>Player In Game Name</th>
                <th>Character Id</th>
                <th>Discord Id</th>
              </tr>
              {row_value.teamDetails.map((teamValue) =>
                <tr>
                  <td>{teamValue?.user_saas_id}</td>
                  <td>{teamValue?.teamUserData?.phoneCode}{" "}{teamValue?.teamUserData?.phone}</td>
                  <td>{teamValue?.isCaptain ? "(C)" : "(O)"}{" "}{teamValue?.playerName}</td>
                  <td>{teamValue?.playerInGameName}</td>
                  <td>{teamValue?.charId}</td>
                  <td>{teamValue?.discordId}</td>
                </tr>
              )}
            </table>
          </div>
        </div>
      )
    }
    else {
      return (
        <div className="row mt-10 pb-10">
          <div className="spinner spinner-dark spinner-lg m-auto"></div>
        </div>
      )
    }
  }

  const CurrencyIcoon = ({ item }) => {
    return (
      <span className="text-dark-50 font-weight-bold">
        {item.currency && item.currency.img ? (
          <img
            className="currency"
            // src={`${process.env.REACT_APP_UPLOADED_FILE_URL}/${item.currency &&
            //   item.currency.img.default}`}
              src={imageUrl(item.currency &&
                item.currency.img.default)}
            alt="currency"
          />
        ) : (
          <span className="text-dark-50 font-weight-bold">₹</span>
        )}
      </span>
    );
  };

  const onClickSortCol = (key) => {
    let show_sort_arrow = showSortArrow;

    Object.keys(show_sort_arrow).forEach(obj_key => {
      if (obj_key === key)
        show_sort_arrow[obj_key] = true;
      else
        show_sort_arrow[obj_key] = false;
    })
    setShowSortArrow(show_sort_arrow);

    // let sort_key = dataFromNestedKeys(key)

    let arrayCopy = [...rows];
    // arrayCopy.sort(compareBy(key, sortDirection[key]));

    if (sortDirection[key] === "asc")
      arrayCopy = sorter.sort(arrayCopy).asc(key);
    else
      arrayCopy = sorter.sort(arrayCopy).desc(key);

    setRows(arrayCopy);
    // this.setState({rows: arrayCopy});

    let sort_direction = sortDirection;
    if (sort_direction[key] === 'asc')
      sort_direction[key] = 'desc';
    else if (sort_direction[key] === 'desc')
      sort_direction[key] = 'asc';
    setSortDirection(sort_direction);
  };

  const createTableCol = () => {
    return (
      allColumns.map((value, i) => {
        if (value?.format?.type !== 'rowCollasible') {
          let style_icon = { color: '#fff' };
          let arrow_direction = 'down';
          let className_cell_value = ''

          if (value?.sort && showSortArrow[value?.dataField])
            style_icon.display = 'inline';
          else
            style_icon.display = 'none';

          if (sortDirection[value?.dataField] === 'asc')
            arrow_direction = 'down';
          else if (sortDirection[value?.dataField] === 'desc')
            arrow_direction = 'up';

          if (value?.dataField === 'image')
            className_cell_value = 'data_table_cell_value_image';
          else
            className_cell_value = 'data_table_cell_value';

          return (
            <th data-field={value?.dataField} data-sort="desc" key={i}
              className="datatable-cell datatable-cell-sort data_table_cell data_table_th"
              onClick={() => { value?.sort === true && onClickSortCol(value?.dataField) }}
              colSpan={1} rowSpan={1} style={value?.format?.thStyle}
            >
              <span className={`${className_cell_value} data_table_th_value`} style={value?.format?.style}>
                {value?.text}
                <i className={`flaticon2-arrow-${arrow_direction} icon-nm ml-1`} style={style_icon}>
                </i>
              </span>
            </th>
          )
        }
      })
    )
  };

  const reloadLocation = () => {
    window.location.reload();
  };

  useEffect(() => {
    setRows([])
    setTotalRecord(0)
    if (acceptedUserList && acceptedUserList?.data?.length > 0) {
      setRows(acceptedUserList?.data);
      setTotalRecord(acceptedUserList?.totalRecord);

      let temp = { ...collasibleRowData };
      for (let i = 0; i < acceptedUserList.data.length; i++) {
        temp[acceptedUserList.data[i].phone] = acceptedUserList.data[i].teamDetails;
      }
      setCollasibleRowData(temp);
    }
  }, [acceptedUserList]);

  const createFormInputs = () => {
    return (
      <div className="report-filter-bLock border-0 row align-items-center" style={{ padding: '0px 0', margin: '0px', }}>
        <Formik
          initialValues={{ phoneEmail: phoneEmail }}
          onSubmit={(values) => {
            console.log('val::22', values);
            applyFilter(values);
          }}
        >
          {({ handleSubmit, values }) => (
            <div className="col-lg-8 col-md-8">
              {/* <div className="row m-0 p-0"> */}
              <form
                onSubmit={handleSubmit}
                className="form form-filter w-100"
                autoComplete="off"
              >
                <div className="form-group row m-0 align-items-center z-index: 10">
                  <div className="col" style={{ maxWidth: '250px', }}>
                    <label>Phone No</label>
                    <Field
                      name="phoneEmail"
                      className={"form-control"}
                      label="Phone No"
                      placeholder="Phone No" //  Phone or Email
                    />
                  </div>

                  <div className="justify-content-end mx-2">
                    <button type="submit" className="btn btn-dark"
                      style={{ width: '130px', marginTop: '20px' }}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </form>
              {/* </div> */}
            </div>

          )}
        </Formik>
      </div>
    )
  };

  const applyFilter = async (values) => {
    setSearchApply(true);
    var tampFilter = { ...filter };

    if (values?.phoneEmail) {
      // tampFilter.phoneNo = values.phoneEmail.replace(/ /g,'')

      if (contestData && contestData?.data && contestData?.data?.tournamentAry) {
        var id = window.location.href.split("/")[
          window.location.href.split("/").length - 1
        ];
        tampFilter.tournamentId = contestData?.data?.tournamentAry?._id
        tampFilter.matchId = id
      }

      if (values?.phoneEmail) {
        let phoneNumber = removeSpecialCharacters(values?.phoneEmail);
        tampFilter.phoneNo = phoneNumber.replace(/ /g,'')
      }
      setFilter(tampFilter);

      if (!listLoading) {
        dispatch(actions.fetchAcceptedUsersList(tampFilter));
      }
    }
    else {
      setSearchApply(false);
      NotificationManager.error("Please enter phone no first.!!", 'Error');
    }
  };

  function removeSpecialCharacters(str) {
    // Regular expression to match special characters
    var regex = /[!@#$%^&*(),.?":{}|<>+-]/g;
  
    // Use the replace() method to remove special characters
    var result = str.replace(regex, '');
  
    return result;
  }

  const DataTablePaginationAPICall = (values) => {
    setSearchApply(true);
    var tampFilter = { ...filter };

    // if (values?.skip) {
    tampFilter.skip = values.skip;
    tampFilter.page = values.page;
    // }
    if (values?.limit) {
      tampFilter.limit = values.limit;
    }

    tampFilter.pagination = {
      pageNo: values.page,
      recordPerPage: values.limit,
      sortBy: "createdAt",
      sortDirection: "asc",
    };

    setFilter(tampFilter);
    // setCount(count + 1);

    if (!listLoading) {
      var id = window.location.href.split("/")[
        window.location.href.split("/").length - 1
      ];
      let obj = {
        tournamentId: contestData?.data?.tournamentAry?._id,
        matchId: id
      }
      dispatch(actions.fetchAcceptedUsersList(obj));
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <Card className="card_border">
            <NotificationContainer />
            <div className="card-header p-0">
              <div className="my-5 row mx-0 px-4 w-100 d-flex justify-content-between">
                {/* <div className="" style={{ fontSize: '24px', fontWeight: '600' }}>User's List</div> */}
                {createFormInputs()}
              </div>
            </div>

            <CardBody className="p-0 w-100">
              {/* {
                  <table className="table dataTable datatable-table contest_data_table_table w-100" style={{ display: 'block', }}>
                    <thead className="datatable-head data_table_head w-100">
                      <tr className="datatable-row" style={{ left: '0px', }}>
                        {createTableCol()}
                      </tr>
                    </thead>

                    <tbody className="datatable-body data_table_body w-100">
                      {rows.length > 0 ?
                        rows.map((value, i) => {
                          var backgroundColor = 'white';
                          if (value?.isRejected)
                            backgroundColor = `#F64E60`;

                          return (
                            <tr data-row={value?._id} className="datatable-row data_table_tr" style={{ left: '0px', backgroundColor: backgroundColor }} key={i}>
                              <td className="datatable-cell data_table_cell">
                                <span className="data_table_cell_value">{i+1}</span>
                              </td>
                              <td className="datatable-cell data_table_cell">
                                <span className="data_table_cell_value">{value?.playerName}</span>
                              </td>
                              <td className="datatable-cell data_table_cell">
                                <span className="data_table_cell_value">{value?.captain_sass_id}</span>
                              </td>
                              <td className="datatable-cell data_table_cell">
                                {value?.teamDetails && value?.teamDetails.length > 0 ?
                                  <>
                                      <tr>
                                          <th>In Game Name</th>
                                          <th>User Name</th>
                                      </tr>
                                      {value.teamDetails.map((teamValue) =>
                                          <tr>
                                              <td>
                                                {teamValue?.playerInGameName}
                                              </td>
                                              <td>{teamValue?.user_saas_id}</td>
                                          </tr>
                                      )}
                                  </>
                                  :
                                  <></>
                                }
                              </td>
                              <td className="datatable-cell data_table_cell">
                                <span className="data_table_cell_value">{value?.userData?.countriesData?.name}</span>
                              </td>
                              <td className="datatable-cell data_table_cell">
                                <span className="data_table_cell_value">{value?.userData?.phone}</span>
                              </td>
                              <td className="datatable-cell data_table_cell">
                                <span className="data_table_cell_value">{value?.userCurrentCurrencyWallet?.inCurrencyWallet ? `${value.userCurrentCurrencyWallet.inCurrencyWallet.winningAmount} ( ${value.userCurrentCurrencyWallet.inCurrencyWallet.userInCurrencyName} )` : <></>}</span>
                              </td>
                              <td className="datatable-cell data_table_cell">
                                <span className="data_table_cell_value">{value?.userCurrentCurrencyWallet?.outCurrencyWallet ? `${value.userCurrentCurrencyWallet.outCurrencyWallet.winningAmount} ( ${value.userCurrentCurrencyWallet.outCurrencyWallet.userInCurrencyName} )` : <></>}</span>
                              </td>
                              <td className="datatable-cell data_table_cell">
                                <span className="data_table_cell_value">{value?.rank || 0}</span>
                              </td>
                              <td className="datatable-cell data_table_cell">
                                <span className="data_table_cell_value">{value?.kill || 0}</span>
                              </td>
                              <td className="datatable-cell data_table_cell">
                                <span className="data_table_cell_value">{columnFormatters.dateFormatCol(value?.createdAt)}</span>
                              </td>
                              <td className="datatable-cell data_table_cell">
                                <span className="data_table_cell_value">{columnFormatters.timeFormatCol(value?.createdAt)}</span>
                              </td>
                              <td className="datatable-cell data_table_cell">
                                <OverlayTrigger
                                  overlay={<Tooltip id="products-edit-tooltip">Allocate Item</Tooltip>}
                                >
                                  <a
                                    className="btn btn-icon btn-light btn-hover-success btn-sm mx-3"
                                    onClick={() => allocateTeam(value._id)}
                                  >
                                    <span className="svg-icon svg-icon-md svg-icon-success">
                                      <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink">
                                        <defs></defs>
                                        <g id="Stockholm-icons-/-General-/-Like" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                          <rect id="bound" x="0" y="0" width="24" height="24"></rect>
                                          <path d="M9,10 L9,19 L10.1525987,19.3841996 C11.3761964,19.7920655 12.6575468,20 13.9473319,20 L17.5405883,20 C18.9706314,20 20.2018758,18.990621 20.4823303,17.5883484 L21.231529,13.8423552 C21.5564648,12.217676 20.5028146,10.6372006 18.8781353,10.3122648 C18.6189212,10.260422 18.353992,10.2430672 18.0902299,10.2606513 L14.5,10.5 L14.8641964,6.49383981 C14.9326895,5.74041495 14.3774427,5.07411874 13.6240179,5.00562558 C13.5827848,5.00187712 13.5414031,5 13.5,5 L13.5,5 C12.5694044,5 11.7070439,5.48826024 11.2282564,6.28623939 L9,10 Z" id="Path-42" fill="#000000"></path>
                                          <rect id="Rectangle-153" fill="#000000" opacity="0.3" x="2" y="9" width="5" height="11" rx="1">
                                          </rect>
                                        </g>
                                      </svg>
                                    </span>
                                  </a>
                                </OverlayTrigger>
                              </td>
                            </tr>
                          )
                        })
                        :
                        <tr className="datatable-row data_table_tr" style={{ left: '0px'}}>
                            <td colSpan={11} className="datatable-cell data_table_cell text-center font-weight-bold">
                                No Data Found
                            </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                } */}
              {
                !searchApply ?
                  <div className="row my-4 w-100 justify-content-center align-items-center" style={{ fontSize: '16px', fontWeight: '600', color: '#80808059'}}>
                    Please enter a valid mobile number to search the team.
                  </div>
                : totalRecord ===0 ?  UIHelpers.dataTableNoData() : <DataTable
                  rows={rows ? rows : []}
                  columns={allColumns}
                  isCollapsibleTableData={true}
                  collasibleRowData={collasibleRowData}
                  paginantionTotalAmountOfData={totalRecord}
                  DataTablePaginationAPICall={DataTablePaginationAPICall}
                  isPagination={rows.length > 0 ? true : false}
              />
              }
              

              {/* <DataTable
                  rows={rows ? rows : []}
                  columns={columns}
                /> */}
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  )
}